import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { TaskTitleDialogComponent } from '../left-side-opener/task-title-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TaskDataSource } from 'src/app/service/task.datasource';
import { DashboardService } from 'src/app/service/dashboard.service';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';
import { BehaviorSubject, fromEvent, Observable } from 'rxjs';
import { MeetingService } from 'src/app/service/meeting.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Globals } from 'src/app/service/global';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { start } from 'repl';
import { MatInput } from '@angular/material/input';

import {
  BreakpointObserver,
  Breakpoints,
  BreakpointState
} from '@angular/cdk/layout';
import { UntypedFormControl } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { PermissionService } from 'src/app/service/permission.service';
import { UtilityService } from 'src/app/service/utility.service';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { environment_msg } from 'src/environments/environment';
import { ConfidentialDialogComponent } from '../confidential-dialog/confidential-dialog.component';

@Component({
  selector: 'app-task',
  templateUrl: './task.component.html',
  styleUrls: ['./task.component.css']

})
export class TaskComponent implements OnInit {


  userName: any;
  componentName = 'TaskPage'
  private readonly notifier!: NotifierService;
  matDialogRef!: MatDialogRef<TaskTitleDialogComponent>;

  options: any
  today: any
  currentDate: any
  checked = false
  // checkboxTracker!: [];
  checkboxTracker: number[] = [];
  checkBoxObj: any[] = [];
  startFilterDate: any;
  endFilterDate: any;

  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.XSmall
  );
  isMedium: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Medium
  )
  isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Small
  )
  @Input()
  deviceXs!: boolean;

  @Input()
  deviceSm!: boolean;

  @Input()
  deviceMd!: boolean;

  @Input()
  deviceLg!: boolean;

  @Input()
  deviceXl!: boolean;

  //UI Team variable declaration
  taskInfoData: any

  readOnlyQuillConfig: any = {
    letter: false,
    modules: {
      toolbar: false
    },
    placeholder: ' ',
    theme: 'snow',
    readOnly: true
  };

  xl = {
    panelClass: ['animate__animated', 'animate__slideInLeft'],
    position: {
      left: "0%"
    },
    maxWidth: "100%",
    width: "50%",
    maxHeight: "100vh",
    height: "100vh"
  }

  lg = {
    panelClass: ['animate__animated', 'animate__slideInLeft'],
    position: {
      left: "0%"
    },
    maxWidth: "100%",
    width: "50%",
    maxHeight: "100vh",
    height: "100vh"
  }

  md = {
    panelClass: ['animate__animated', 'animate__slideInLeft'],
    position: {
      left: "0%"
    },
    maxWidth: "100%",
    width: "50%",
    maxHeight: "100vh",
    height: "100vh"
  }

  sm = {
    panelClass: ['animate__animated', 'animate__slideInLeft'],
    position: {
      left: "0%"
    },
    width: "calc(100% - 100px)",
    height: "calc(100% - 0px)",
  }

  xs = {
    panelClass: ['animate__animated', 'animate__slideInLeft'],
    position: {
      left: "0%"
    },
    width: "calc(100% - 100px)",
    height: "calc(100% - 0px)",
  }

  disabled = false;
  compact = true;
  invertX = false;
  invertY = false;

  completed = "COMPLETED";
  overdue = "OVERDUE";
  ongoing = "ONGOING";
  pending = "PENDING";


  shown: 'native' | 'hover' | 'always' = 'native';
  taskDataSource!: TaskDataSource;
  taskJSON: any;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('input', { static: true })
  input!: ElementRef;
  @ViewChild('start', { static: true, read: MatInput })
  startDa!: MatInput
  displayedColumns = ["dueDate", "taskTitle", "getdetails"];
  meetingInfoData: any;
  taskId: any = [];

  @ViewChild('end', { static: true, read: MatInput })
  endDa!: MatInput
  dateRangeArray: any = [];
  isShown: boolean = false;
  private countTasks = new BehaviorSubject<number>(0);
  constructor(private sideNav: SideNavServiceService, private permissionService: PermissionService, private util: UtilityService, public sideNavService: SideNavServiceService, private readonly breakpointObserver: BreakpointObserver, notifierService: NotifierService, private meetingService: MeetingService, private globals: Globals, private spinner: NgxSpinnerService, private dialog: MatDialog, private dashboardService: DashboardService, private router: Router) {
    this.notifier = notifierService;
    this.userName = localStorage.getItem('userName');

    this.taskJSON =
    {
      "actionItemStatus": ["P", "RV"],
      "displayConfig": this.globals.settingValuesList.UPCOMING_TASK_CONF,
      "orgCode": "CHN",
      "idisplayStart": 0,
      "idisplayLength": 10,
      "taskCategory": "UPCOMING",
      "taskType": "UPCOMING",
      "userId": localStorage.getItem("userId"),
      "taskDisplayConfig": "1",
      "visitorTimezone": this.globals.vTimeZone,
      "startDate": "",
      "endDate": ""
    }
  }

  triggerCall() {
    window.alert("called")

  }

  calendar = new UntypedFormControl()

  checkBoxTracker(i: any, id: any, event: any) {


    let one = document.getElementById(i) as HTMLInputElement

    if (event.target.checked) {

      this.checkBoxObj.push(id);
      this.checkboxTracker.push(i)
      this.taskId.push(id);
      this.checked = true;
    }
    else if (event.target.checked == false) {
      // window.alert("removed")
      this.checkBoxObj.splice(this.checkBoxObj.indexOf(id), 1)
      this.checkboxTracker.splice(0, 1)
      this.taskId.splice(0, 1);
      //
      if (this.checkboxTracker.length == 0) {
        this.checked = false
      }
    }

    //

    ////consolee.log("checkbox tracker",this.checkboxTracker);
    ////consolee.log("taskIds",this.taskId.toString()+",");
    // if(this.checkboxTracker.length == 0){
    //   window.alert("called")
    //   this.checked = true;
    // }
    // else{
    //   this.checked = false
    // }
    // if(this.checkBoxTracker.length != 0){
    //   this.checked = true
    // }
    // else if(){
    //   this.checked = false
    // } 
  }

  ngOnInit(): void {
    this.options = {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    }
    this.today = new Date();
    this.currentDate = this.today.toLocaleDateString("en-US", this.options);

    this.taskDataSource = new TaskDataSource(this.dashboardService);

    this.taskJSON.idisplayStart = 0;
    this.taskJSON.idisplayLength = 10;
    this.taskJSON.filterTxt = this.input.nativeElement.value;
    this.taskJSON.filterCol = "taskTitle";
    this.taskDataSource.loadTasks(this.taskJSON);
    let dateRangeFilter = <HTMLElement>document.getElementById('date-range-filter');
    dateRangeFilter.setAttribute('hidden', 'true')
    //
  }

  ngOnChanges() {
    if ((!this.deviceXl || !this.deviceLg) && this.sideNavService.returnExpandFullScreeBooleanSetter()) {
      // this.sideNavService.expandFullScreenBooleanSetter(false,'task-card-container','panel-fullscreen')
    }
    else {
      // this.sideNavService.expandFullScreenBooleanSetter(false,'task-card-container','panel-fullscreen-mb-view')
    }
  }

  //UI Team Changes
  loadTaskInfo(taskId: any, meetingId: any) {
    var accessFlag = this.permissionService.checkUserRightsWithAlert(this.util.featureList.TASK, this.util.permissionType.READ);
    if (!accessFlag) {
      return;
    }
    this.spinner.show();
    this.meetingService.fetchMeetingInfo(meetingId).subscribe(
      (meetingRes: any) => {
        this.meetingInfoData = meetingRes.body
        this.spinner.hide();
        if (this.meetingInfoData.isConfidential == 'Y') {
          let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
            panelClass: ['animate__animated', 'animate__slideInRight'],
            disableClose: true,
            position: {
              left: "50%"
            },
            maxWidth: "100%",
            maxHeight: "100vh",
            width: "50%",
            data: { isConfidentialCheck: true, meetingObj: this.meetingInfoData, flag: true, loadTask: true, taskID: taskId, taskJSON: this.taskJSON }
          })
          const mediumDialogSubscription = this.isMedium.subscribe(size => {
            if (size.matches) {
              dialogRef.updateSize('70vw', '100vh');
            }
          })
          const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
            if (size.matches) {
              dialogRef.updateSize('100vw', '100vh');
            } else {
              dialogRef.updateSize('calc(100% - 50px)', '100vh');
            }
          });
          const smallSubscription = this.isSmall.subscribe(size => {
            if (size.matches) {
              dialogRef.updateSize('100vw', '100vh');
            }
          })
          dialogRef.afterClosed().subscribe((data) => {
            mediumDialogSubscription.unsubscribe()
            smallSubscription.unsubscribe()
            smallDialogSubscription.unsubscribe()
          });



        }




        else {
          this.meetingService.fetchTaskInfo(taskId).subscribe(
            (meetingRes: any) => {
              this.taskInfoData = meetingRes.body;
              this.matDialogRef = this.dialog.open(TaskTitleDialogComponent, {
                data: { taskData: this.taskInfoData, meetingData: this.meetingInfoData },
                panelClass: ['animate__animated', 'animate__slideInLeft'],
                disableClose: true,
                position: {
                  left: "0%"
                },
                maxWidth: "100%",
                maxHeight: "100vh",
                width: "50%",
                height: "100vh"
              });
              const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
                if (size.matches) {
                  this.matDialogRef.updateSize('100vw', '100vh');
                } else {
                  this.matDialogRef.updateSize('50%', '100vh');
                }
              });
              const mediumDialogSubscription = this.isMedium.subscribe(size => {
                if (size.matches) {
                  this.matDialogRef.updateSize('70vw', '100vh');
                }
              })
              const smallSubscription = this.isSmall.subscribe(size => {
                if (size.matches) {
                  this.matDialogRef.updateSize('100vw', '100vh');
                }
              })
              this.matDialogRef.afterClosed().subscribe((data: any) => {
                this.taskDataSource.loadTasks(this.taskJSON);
                mediumDialogSubscription.unsubscribe();
                smallDialogSubscription.unsubscribe();
                smallSubscription.unsubscribe();
              });

              // d.afterClosed().subscribe(() => {
              // });
            });
        }
      });


    //this.cdr.markForCheck();
    //this.ngxSpinner.hide();
  }

  startDateSelection(event: any) {
    /*console.log("startDateSelection event",event)
    this.startFilterDate = event.value
 
    let startDate = new Date(this.startFilterDate)
 
    // Saturday, March 19, 2022
    
    this.startFilterDate = startDate.toLocaleDateString('en-US',{ weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })
 
  */
  }

  endDateSelection(event: any) {
    /*console.log("endDateSelection event",event)
    this.endFilterDate = event.value
 
    let endDate = new Date(this.endFilterDate)
    this.endFilterDate = endDate.toLocaleDateString('en-US',{ weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })
 
 
    let filteredArray = this.taskDataSource.meetingSubject['_value'].filter((x : any) => {
      let actionItemDateCreator = new Date(x.actionItemDueDate)
      let dateConstructor = actionItemDateCreator.toLocaleDateString('en-US',{ weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })
 
      if(new Date(this.startFilterDate).getDate() <= new Date(dateConstructor).getDate() && new Date(this.startFilterDate).getMonth() <= new Date(dateConstructor).getMonth() && new Date(this.startFilterDate).getFullYear() <= new Date(dateConstructor).getFullYear() && new Date(this.endFilterDate).getDate() >= new Date(dateConstructor).getDate() && new Date(this.endFilterDate).getMonth() >= new Date(dateConstructor).getMonth() && new Date(this.endFilterDate).getFullYear() >= new Date(dateConstructor).getFullYear()){
   
        // this.taskDataSource.meetingSubject['_value']
        return x;
      }
    })
    if(filteredArray.length == 0){
      // window.alert("No data matched")
      this.notifier.show({
        type: 'error',
        message: 'No Data Matched'
        });
    }
    else{      
      this.dateRangeArray = filteredArray
    }
    // this.taskDataSource.meetingSubject['_value'] = [];
    // this.taskDataSource.meetingSubject['_value'] = filteredArray
    */
  }

  triggerRefresh(num: number) {
    if (num == 0) {
      this.input.nativeElement.value = "";
      this.calendar.reset();
      this.startFilterDate = "";
      this.endFilterDate = "";
      this.taskDataSource = new TaskDataSource(this.dashboardService);

      this.taskJSON.idisplayStart = 0;
      this.taskJSON.idisplayLength = ((this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceXl) || (this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceLg) ? 20 : 10);
      this.taskJSON.size = ((this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceXl) || (this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceLg) ? 20 : 10);
      this.taskJSON.filterTxt = this.input.nativeElement.value;
      // this.meetingJSON.filterTxt = "recursive";

      this.taskJSON.filterCol = "taskTitle";
      this.taskJSON.startDate = "";
      this.taskJSON.endDate = "";
      this.taskDataSource.loadTasks(this.taskJSON);
      this.refreshTabs();
      // this.isShown = !this.isShown;
      this.toggleFilter('search')
    }
    else {
      this.taskJSON.idisplayLength = ((this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceXl) || (this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceLg) ? 20 : 10);
      this.taskJSON.size = ((this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceXl) || (this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceLg) ? 20 : 10);
      this.taskDataSource.loadTasks(this.taskJSON);
    }
  }


  toggleFilter(filterName: any) {
    let dateRangeFilter = <HTMLElement>document.getElementById('date-range-filter');
    let searchFilter = <HTMLElement>document.getElementById('search-filter');
    this.paginator.pageIndex = 0;
    switch (filterName) {
      case "search":
        dateRangeFilter.hidden = true;
        searchFilter.hidden = false;
        break;
      case "oneWeek":
        this.startFilterDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 6);
        this.endFilterDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
        // this.startFilterDate = new Date();    
        // this.endFilterDate =  new Date(new Date().setDate(new Date().getDate() - (new Date().getDay() - 1) - 6))
        this.isShown = true;
        this.taskJSON.startDate = this.startFilterDate;
        this.taskJSON.endDate = this.endFilterDate;
        this.taskJSON.idisplayStart = this.paginator.pageIndex;
        this.taskJSON.idisplayLength = this.paginator.pageSize;

        this.taskDataSource.loadTasks(this.taskJSON);
        dateRangeFilter.hidden = false;
        searchFilter.hidden = true;
        break;
      case "twoWeek":
        this.startFilterDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
        this.endFilterDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 6);
        this.isShown = true;
        this.taskJSON.startDate = this.startFilterDate;
        this.taskJSON.endDate = this.endFilterDate;
        this.taskJSON.idisplayStart = this.paginator.pageIndex;
        this.taskJSON.idisplayLength = this.paginator.pageSize;

        this.taskDataSource.loadTasks(this.taskJSON);
        dateRangeFilter.hidden = false;
        searchFilter.hidden = true;
        break;
      case "nxtTwoWeek":
        this.startFilterDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
        this.endFilterDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 13);
        this.isShown = true;
        this.taskJSON.startDate = this.startFilterDate;
        this.taskJSON.endDate = this.endFilterDate;
        this.taskJSON.idisplayStart = this.paginator.pageIndex;
        this.taskJSON.idisplayLength = this.paginator.pageSize;

        this.taskDataSource.loadTasks(this.taskJSON);
        dateRangeFilter.hidden = false;
        searchFilter.hidden = true;
        break;
      case "dateRange":
        // this.triggerRefresh()
        this.isShown = true;
        document.getElementById('calendar-click-icon-t')?.click()
        this.startFilterDate = "";
        this.endFilterDate = "";
        dateRangeFilter.hidden = false;
        searchFilter.hidden = true;
        break;
    }
  }

  triggerAlert() {


    this.isShown = true;
    this.taskJSON.startDate = this.startFilterDate;
    this.taskJSON.endDate = this.endFilterDate;
    this.taskJSON.idisplayStart = 0;
    this.taskJSON.idisplayLength = this.paginator.pageSize;

    this.taskDataSource.loadTasks(this.taskJSON);

    // this.dashboardService.loadTasks(this.taskJSON).subscribe(res=>{

    //  this.taskDataSource=res.dataList;
    //  this.countTasks.next(res.totalCount);
    // });
    // window.alert("startFilterDate"+this.startFilterDate+"endFilterDate"+this.endFilterDate);
    /*let startDate = new Date(this.startFilterDate)
    let newStartFilterDate: string | number | Date;
    let newEndFilterDate: string | number | Date;
 
    // Saturday, March 19, 2022
    
    newStartFilterDate = startDate.toLocaleDateString('en-US',{ weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })
 
    let endDate = new Date(this.endFilterDate)
    newEndFilterDate = endDate.toLocaleDateString('en-US',{ weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })
 
 
    let filteredArray = this.taskDataSource.meetingSubject['_value'].filter((x : any) => {
      let actionItemDateCreator = new Date(x.actionItemDueDate)
      let dateConstructor = actionItemDateCreator.toLocaleDateString('en-US',{ weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })
 
      if(new Date(newStartFilterDate).getDate() <= new Date(dateConstructor).getDate() && new Date(newStartFilterDate).getMonth() <= new Date(dateConstructor).getMonth() && new Date(newStartFilterDate).getFullYear() <= new Date(dateConstructor).getFullYear() && new Date(newEndFilterDate).getDate() >= new Date(dateConstructor).getDate() && new Date(newEndFilterDate).getMonth() >= new Date(dateConstructor).getMonth() && new Date(newEndFilterDate).getFullYear() >= new Date(dateConstructor).getFullYear()){
   
        // this.taskDataSource.meetingSubject['_value']
        return x;
      }
    })
    if(filteredArray.length == 0){
      // window.alert("No data matched")
      this.notifier.show({
        type: 'error',
        message: 'No Data Matched'
        });
    }
    else{      
      this.dateRangeArray = filteredArray
    }*/
  }

  triggerFilter() {
    window.alert("triggered")
  }

  //taskItems = taskList
  ngAfterViewInit() {
    this.taskDataSource.counter$
      .pipe(
        tap((count) => {
          this.paginator.length = count;
          //this.isLoading = true;
        })
      )
      .subscribe();
    fromEvent(this.input.nativeElement, 'keyup')
      .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap(() => {
          this.loadTasks();
        })
      )
      .subscribe();
    this.paginator.page
      .pipe(
        tap(() => this.loadTasks())
      )
      .subscribe();
    setTimeout(() => {
      const ele = document.getElementsByClassName('mat-mdc-tab-header')[0] as HTMLElement;
      ele.style.borderBottom = "0.5px solid #ccc"
    }, 50)
  }

  loadTasks() {
    this.taskJSON.idisplayStart = this.paginator.pageIndex;
    this.taskJSON.idisplayLength = this.paginator.pageSize;
    this.taskJSON.filterTxt = this.input.nativeElement.value;
    this.taskJSON.filterCol = "taskTitle";

    this.taskDataSource.loadTasks(this.taskJSON);
  }

  openTaskDetails() {
    if (this.deviceLg) {
      this.dialog.open(TaskTitleDialogComponent, this.lg)
    }
    if (this.deviceMd) {
      this.dialog.open(TaskTitleDialogComponent, this.md)
    }
    if (this.deviceSm) {
      this.dialog.open(TaskTitleDialogComponent, this.sm)
    }
    if (this.deviceXs) {
      this.dialog.open(TaskTitleDialogComponent, this.xs)
    }
    if (this.deviceXl) {
      this.dialog.open(TaskTitleDialogComponent, this.xl)
    }
  }

  updateGroupTask() {
    var accessFlag = this.permissionService.checkUserRightsWithAlert(this.util.featureList.TASK, this.util.permissionType.MODIFY);

    if (!accessFlag) {
      return;
    }

    var taskJson = {
      "modifiedTaskIds": this.taskId.toString() + ",",
      "createdBy": this.globals.userId
    }
    //
    this.meetingService.updateGroupTask(taskJson).subscribe(
      (meetingRes: any) => {
        //
        this.taskId = [];
        this.taskDataSource.loadTasks(this.taskJSON);
        this.checked = false;
        this.notifier.show({
          type: 'success',
          message: environment_msg.msg_success_task_complete
        });
      });
  }
  tabChanged(event: any) {
    //
    //
    if (event.index == 0) {
      this.taskJSON.taskType = "UPCOMING";
      this.taskJSON.taskCategory = "UPCOMING";
    } else if (event.index == 1) {
      this.taskJSON.taskType = "ALL";
      this.taskJSON.taskCategory = "ALL";
      this.taskJSON.startDate = this.startFilterDate;
      this.taskJSON.endDate = this.endFilterDate;
    }
    this.taskDataSource = new TaskDataSource(this.dashboardService);
    this.taskJSON.idisplayStart = 0;
    this.taskJSON.idisplayLength = 10;
    this.taskJSON.filterTxt = this.input.nativeElement.value;
    this.taskJSON.filterCol = "taskTitle";
    this.taskDataSource.loadTasks(this.taskJSON);
    //
    this.refreshTabs();
    this.triggerRefresh(0)
  }
  refreshTabs() {
    this.taskDataSource.counter$
      .pipe(
        tap((count) => {
          this.paginator.length = count;
        })
      )
      .subscribe();
    fromEvent(this.input.nativeElement, 'keyup')
      .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap(() => {
          this.loadTasks();
        })
      )
      .subscribe();
    this.paginator.page
      .pipe(
        tap(() => this.loadTasks())
      )
      .subscribe();
  }
  redirectToMeeting(meeting: any) {
    var accessFlag = this.permissionService.checkUserRightsWithAlert(this.util.featureList.MEETINGS, this.util.permissionType.MODIFY);
    if (!accessFlag) {
      return;
    }
    var meetingJson = {

      "meetingStatusCode": meeting.meetingStatus,
      "isConfidential": meeting.isConfidential,
      "meetingId": meeting.meetingId,
      "meetingTitle": meeting.meetingTitle
    }
    this.meetingService.fetchMeetingWithStatusObject(meeting.meetingId).subscribe(
      (meetingRes: any) => {
        var meetingobject = meetingRes.body
        if (meetingobject.isConfidential == "Y" || meetingobject.isConfidential == "YES") {
          if (meetingobject.meetingStatusCode == "SCH") {
            let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
              panelClass: ['animate__animated', 'animate__slideInRight'],
              disableClose: true,
              position: {
                left: "50%"
              },
              maxWidth: "100%",
              maxHeight: "100vh",
              width: "50%",
              height: "100vh",
              data: (meetingobject.rescheduleflag == "Y" && meetingobject.meetingStartFlag == null ? { isConfidentialCheck: true, meetingObj: meetingJson, flag: true, meetingStartFlag: "" } : { isConfidentialCheck: true, meetingObj: meetingJson, flag: true, meetingStartFlag: "Y" })
            })
          } else {
            let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
              panelClass: ['animate__animated', 'animate__slideInRight'],
              disableClose: true,
              position: {
                left: "50%"
              },
              maxWidth: "100%",
              maxHeight: "100vh",
              width: "50%",
              height: "100vh",
              data: { isConfidentialCheck: true, meetingObj: meetingJson, flag: true, showMoM: true }
            })

            const mediumDialogSubscription = this.isMedium.subscribe(size => {
              if (size.matches) {
                dialogRef.updateSize('70vw', '100vh');
              }
            })
            const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
              if (size.matches) {
                dialogRef.updateSize('100vw', '100vh');
              } else {
                dialogRef.updateSize('calc(100% - 50px)', '100vh');
              }
            });
            const smallSubscription = this.isSmall.subscribe(size => {
              if (size.matches) {
                dialogRef.updateSize('100vw', '100vh');
              }
            })
            dialogRef.afterClosed().subscribe((data) => {
              mediumDialogSubscription.unsubscribe()
              smallSubscription.unsubscribe()
              smallDialogSubscription.unsubscribe()
            });
          }
        } else {
          var req: any = { "meetingId": meeting.meetingId };
          if (meetingobject.meetingStatusCode == "SCH") {
            if (meetingobject.rescheduleFlag == "Y" && (meetingobject.meetingStartFlag == null || meetingobject.meetingStartFlag == undefined)) {
              req = { "meetingId": meeting.meetingId, "flag": true, "meetingStartFlag": "", "rescheduleflag": "Y" }
            } else {
              this.sideNav.openInstantMeeting(true)
              req = { "meetingId": meeting.meetingId, "flag": true, "meetingStartFlag": "Y" }
            }
          } else {
            req = { "meetingId": meeting.meetingId, "flag": true, showMoM: true }
          }
          this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify(req) }, skipLocationChange: true, replaceUrl: false });
        }
      });

  }


  
}
